export class AccountValidationModel {
  password: string;

  constructor(password: string) {
    this.password = password;
  }
}
